import Enum from './Enum';

class DepositOrderStatus extends Enum {
  INIT = 1;

  PAID = 3;

  COMPLETED = 5;

  REFUNDED = 6;

  labels() {
    const labels = {};
    labels[this.INIT] = 'Placed';
    labels[this.PAID] = 'Paid';
    labels[this.COMPLETED] = 'Completed';
    labels[this.REFUNDED] = 'Refunded';
    return labels;
  }
}

export default new DepositOrderStatus();
